<template>
  <div>
    <!-- Page header -->
    <div class="flex flex-wrap items-center justify-between pb-4 py-1">
      <div>
        <h1 class="text-xl font-semibold text-gray-800">Facility Settings</h1>
        <p class="text-sm text-gray-500 mt-0.5">Manage your facility configuration and tools</p>
      </div>
    </div>

    <!-- Tab navigation -->
    <div class="tabs flex space-x-4 border-b mb-6">
      <button
        class="px-4 py-2 -mb-px font-semibold border-b-2 transition-colors"
        :class="{'border-custom-yellow text-custom-blue': currentTab === 'facility-tools', 'border-transparent text-gray-500 hover:text-gray-700': currentTab !== 'facility-tools'}"
        @click="currentTab = 'facility-tools'"
      >
        Facility Tools
      </button>
      <button
        class="px-4 py-2 -mb-px font-semibold border-b-2 transition-colors"
        :class="{'border-custom-yellow text-custom-blue': currentTab === 'facility-qr', 'border-transparent text-gray-500 hover:text-gray-700': currentTab !== 'facility-qr'}"
        @click="currentTab = 'facility-qr'"
      >
        Facility QR Code
      </button>
      <button
        class="px-4 py-2 -mb-px font-semibold border-b-2 transition-colors"
        :class="{'border-custom-yellow text-custom-blue': currentTab === 'login-activity', 'border-transparent text-gray-500 hover:text-gray-700': currentTab !== 'login-activity'}"
        @click="currentTab = 'login-activity'"
      >
        Login Activity
      </button>
    </div>

    <component
      :is="currentTabComponent"
      ref="currentTabComponent"
    />
  </div>
</template>

<script>
import FacilityTools from '@/views/pages/facility_admin/Settings/FacilityTools.vue'
import FacilityQRCode from '@/views/pages/facility_admin/Settings/FacilityQRCode.vue'
import UserLoginActivity from '@/views/pages/facility_admin/Settings/UserLoginActivity.vue'

export default {
  name: 'FacilitySettingsDashboardPage',
  components: {
    FacilityTools,
    FacilityQRCode,
    UserLoginActivity
  },

  data() {
    return {
      currentTab: 'facility-tools'
    }
  },

  computed: {
    currentTabComponent() {
      switch (this.currentTab) {
        case "facility-tools":
          return 'FacilityTools'
        case "facility-qr":
          return 'FacilityQRCode'
        case "login-activity":
          return 'UserLoginActivity'
        default:
          return 'FacilityTools'
      }
    }
  }
}
</script>

<style scoped>
</style>